<svg xmlns="http://www.w3.org/2000/svg" viewBox="-32 -32 832 832">
  <path
    fill="#e21b1b"
    d="M384 0C172.8 0 0 172.8 0 383.999c0 211.2 172.8 384 384 384s384-172.8 384-384C768 172.8 595.2 0 384 0Zm0 85.33c66.133 0 128 23.47 179.2 59.74L145.067 563.199c-36.267-51.2-59.734-113.067-59.734-179.2C85.333 219.732 219.733 85.33 384 85.33Zm0 597.336c-66.133 0-128-23.467-179.2-59.734l418.133-418.133c36.267 51.2 59.734 113.067 59.734 179.2 0 164.267-134.4 298.667-298.667 298.667Z"
  />
</svg>
